import type { RowSelectionState } from '@tanstack/react-table'
import { Trash2Icon } from 'lucide-react'

import { Button } from '@/components/ui'
import { DeleteTransactionsDialog, type Transaction } from '@/modules/projects'
import { useDialogActions } from '@/stores'
import { BulkEditDropdown } from './BulkEditDropdown'
import type { TransactionsTableVariant } from './columns'

interface TransactionsBulkActionsProps {
  selection: RowSelectionState
  transactions: Transaction[]
  variant?: TransactionsTableVariant
}

export const TransactionsBulkActions = ({
  selection,
  transactions,
  variant = 'transactions',
}: TransactionsBulkActionsProps) => {
  const { openDialog } = useDialogActions()
  const getSelected = () =>
    transactions.filter((transaction) => selection[transaction.id])

  return (
    <>
      <BulkEditDropdown getTransactions={getSelected} variant={variant} />
      <Button
        theme="destructive"
        size="sm"
        onClick={() =>
          openDialog(DeleteTransactionsDialog.id, {
            transactions: getSelected(),
            variant,
          })
        }
        className="h-8 gap-1.5 text-xs"
      >
        <Trash2Icon className="size-3.5" />
        Delete
      </Button>
    </>
  )
}
